import React from 'react'

export const Pandahxb = () => {
  const imageStyle = {
    width: '150px',
    height: '150px',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid white',
  };
  return (
    <div>
      <h1>About Me - pandahxb</h1>
      <img
          src="Kai.jpg"
          alt="Kai"
          style={imageStyle}
      />
      <p>I am Kai, a senior majoring in computer science. I have experience in front-end design and web development, having worked in a team to develop a web application using Flask. I am also passionate about music production. I am multilingual and can speak English, Mandarin, and Cantonese.</p>
    </div>
  )
}
